/* 
 * 机构管理模块
 */

// 保存
export function save() {
  return {
    url: 'dept/save',
    type: 'post',
    data: {
      "code": 200,
      "msg": null,
      "data": 1
    }
  }
}
// 批量删除
export function batchDelete() {
  return {
    url: 'dept/delete',
    type: 'post',
    data: {
      "code": 200,
      "msg": null,
      "data": 1
    }
  }
};
import deptData from './dept/deptData.js';
export function findDeptTree(params) {
  // 查询机构树
  let findTreeData = deptData;
  return {
    url: 'dept/findTree',
    type: 'get',
    data: findTreeData
  }
}



// WEBPACK FOOTER //
// ./src/mock/modules/dept.js